import { FormOutlined } from "@ant-design/icons";
import { type FunctionComponent } from "react";
import { Grey7 } from "styles/antTheme/Colors";

import { type IBTIconProps } from "../BTIcon.types";
import { useAntIcon } from "../BTIcon.utilities";

export const BTIconFormOutlined: FunctionComponent<IBTIconProps> = (baseProps) => {
    const [props] = useAntIcon(baseProps);

    return <FormOutlined {...props} style={{ ...props.style, color: Grey7 }} />;
};
